import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './styles/globals.css';
import './styles/variables.css';

// Context
import { AppProvider } from '@/contexts/AppContext';

// Pages
import Home from '@/pages/Home/Home';
import VisionPage from '@/pages/VisionPage/VisionPage';
import ProgramsPage from '@/pages/ProgramsPage/ProgramsPage';
import TeamPage from '@/pages/TeamPage/TeamPage';
import DonationPage from '@/pages/DonationPage/DonationPage';
import GalleryPage from '@/pages/GalleryPage/GalleryPage';
import ContactPage from '@/pages/ContactPage/ContactPage';
import AdminPage from '@/pages/Admin/AdminPage';

// Components
import Navbar from '@/components/Navbar/Navbar';
import Footer from '@/components/Footer/Footer';

// Admin route protection
const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = localStorage.getItem('adminToken') !== null;
  return isAuthenticated ? children : <Navigate to="/admin" replace />;
};

function App() {
  return (
    <AppProvider>
      <Router>
      <div className="app" style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        minHeight: '100vh' 
      }}>
        <Navbar />
        <main style={{ 
          flex: '1 0 auto', 
          width: '100%',
          marginTop: '0' 
        }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/vision" element={<VisionPage />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/donate" element={<DonationPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={
              localStorage.getItem('adminToken') ? 
                <Navigate to="/admin/dashboard" replace /> : 
                <AdminPage />
            } />
            <Route path="/admin/dashboard" element={
              <AdminRoute>
                <AdminPage />
              </AdminRoute>
            } />
            
            {/* Catch all other routes and redirect to home */}
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
    </AppProvider>
  );
}

export default App;
